import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { withSpacing } from '../../util/spacing.js';
import styled from 'styled-components';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BoxStyled = /*#__PURE__*/styled(withSpacing('div')).withConfig({
  displayName: "Boxstyled__BoxStyled",
  componentId: "sc-1uxnie0-0"
})(function (props) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    WebkitTapHighlightColor: 'transparent'
  }, props.$css), props.$q), props.$interactiveState), props.$interactiveWithinState), props.$hideScrollbar ? {
    /* stylelint-disable-next-line function-no-unknown */
    MsOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  } : {}), props.$empty === 'hidden' ? {
    '&:empty': {
      display: 'none'
    }
  } : {}), props.$safeArea && {
    paddingTop: props.$safeArea.top && 'env(safe-area-inset-top)',
    paddingBottom: props.$safeArea.bottom && 'env(safe-area-inset-bottom)',
    paddingLeft: props.$safeArea.left && 'env(safe-area-inset-left)',
    paddingRight: props.$safeArea.right && 'env(safe-area-inset-right)'
  }), props.$overflowScrolling && {
    '-webkit-overflow-scrolling': props.$overflowScrolling
  });
});

export { BoxStyled };
//# sourceMappingURL=Box.styled.js.map
